import React from 'react';
import { useSelector } from 'react-redux';

import { STATS_COLUMNS } from 'widgets/statspro/js/components/common/config/columns';
import {
    statsLeadersSortSelector,
    seasonSelector,
    roundSelector
} from 'store/modules/statspro/stats-leaders/selectors';
import { Loader } from 'common/react/components/Loader';
import { getTranslation } from 'common/react/utils/translations';

/**
 * @typedef {object} Props
 * @property {object} sort
 * @property {object} season
 * @property {object} round
 */

/**
 * @returns {JSX.Element} Loader or heading.
 */
export const Heading = () => {
    const sort = useSelector(statsLeadersSortSelector);
    const season = useSelector(seasonSelector);
    const round = useSelector(roundSelector);

    if (!season || !sort.columnId) {
        return <Loader />;
    }

    const sortByColumn = STATS_COLUMNS[sort.columnId]?.name;

    // eslint-disable-next-line no-magic-numbers
    const seasonYear = season.providerId.slice(4, 8);

    return (
        <>
            <strong>
                {sortByColumn ||
                    getTranslation('label.statspro.defaultSortTitle')}
            </strong>{' '}
            - {seasonYear} Season {round && `(Round ${round.roundNumber})`}
        </>
    );
};
